import { render, staticRenderFns } from "./baustellen.vue?vue&type=template&id=33d1661c&scoped=true&"
import script from "./baustellen.vue?vue&type=script&lang=js&"
export * from "./baustellen.vue?vue&type=script&lang=js&"
import style0 from "./baustellen.vue?vue&type=style&index=0&id=33d1661c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d1661c",
  null
  
)

export default component.exports